import React from "react";
import { FieldInput, FieldInputDollar } from "../Forms";
import { Field } from "formik";
import { camelCase, get, isEmpty } from "lodash";
import permissions from "../../mocks/menuPermissions.json";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationTriangle,
  faTrashAlt,
} from "@fortawesome/pro-solid-svg-icons";
import AddToolTip from "../AddToolTip/AddToolTip";
import { usCurrency } from "../../utils";

const PayrollCardBody = ({
  values,
  fieldName,
  handleCompensationChange,
  check,
  errorList,
  index,
  compensationType,
  disabled,
  showAcceptWarning,
  payrollError,
  compensation,
  showClass,
  fullText,
  isCompensation = false,
  isContribution = false,
  isLoan = false,
  handleChange,
  handleContributionChange,
  errorItem,
  planId,
  menu,
  subMenu,
  roleName,
  removeOne,
  contribution,
  errorType = null,
  setDeleteContributionId,
  setIsModalOpen,
}) => {
  const controlName = isCompensation
    ? "compensations"
    : isContribution
    ? "contributions"
    : "payrollLoans";

  var error = null;

  switch (controlName) {
    case "compensations":
      error = get(errorList, fieldName, null);
      break;
    case "contributions":
      error = get(errorList, `${fieldName}.contributionAmount`, null);
      break;
    case "payrollLoans":
      error = get(errorList, `${fieldName}.repaymentAmount`, null);
      break;
    default:
      error = null;
      break;
  }

  var warningCheck = errorType == 2 && !disabled ? true : false;

  return (
    <div class="payroll-accept-card">
      <div className="ft-12 d-flex flex-cloumn align-items-baseline w-100">
        {isCompensation ? (
          <>
            <p className="m-0 column-compensation-plan-details">
              {compensationType}
            </p>
            <div className="column-compensation-amount">
              {console.log(
                "bjbn",
                get(values, `${fieldName}`),
                values,
                fieldName
              )}
              <Field
                size="xs"
                name={fieldName}
                autoComplete="off"
                disabled={disabled}
                max={999999999.99}
                min={-999999999.99}
                onChange={(e) => {
                  handleCompensationChange(
                    e,
                    values.modeOfCompensation,
                    1,
                    fieldName,
                    index
                  );
                }}
                value={
                  get(values, `${fieldName}`) === null
                    ? ""
                    : get(values, `${fieldName}`)
                }
                isWarning={!disabled && warningCheck}
                ignoreError={true}
                isGreyInputBox={true}
                component={FieldInputDollar}
              />
            </div>
            <div className="column-compensation-action">
              {showAcceptWarning ? (
                <a
                  className="accept-warning"
                  onClick={() => check(get(errorList, fieldName))}
                >
                  <i
                    class="fas fa-exclamation-triangle mr-1"
                    aria-hidden="true"
                    style={{ color: "rgb(167, 123, 0)" }}
                  ></i>
                  Accept Warning
                </a>
              ) : (
                <span className="payroll-null-data">NA</span>
              )}
            </div>
          </>
        ) : isContribution ? (
          <>
            <div className="column-contribution-plan-id">
              <AddToolTip name={planId} />
            </div>
            <div className="column-contribution-source">
              <AddToolTip name={contribution?.sourceName} />
            </div>
            <div className="column-contribution-pay-period mr-1">
              <Field
                name={`${fieldName}.contributionAmount`}
                disabled={disabled}
                size="xs"
                autoComplete="off"
                value={
                  get(values, `${fieldName}.contributionAmount`) === null
                    ? ""
                    : get(values, `${fieldName}.contributionAmount`)
                }
                max={999999999.99}
                min={-999999999.99}
                // value={contAmt}
                ignoreError={true}
                onChange={(e) => {
                  handleContributionChange(
                    e,
                    `${fieldName}.contributionAmount`,
                    index
                  );
                }}
                isWarning={warningCheck}
                component={FieldInputDollar}
              />
            </div>
            <div className="column-contribution-ytd">
              <>
                <div
                  name={`${fieldName}.ytdContributionAmount`}
                  style={{ alignItem: "center" }}
                  className={contribution?.errorMessages
                    ?.map((_, i) => {
                      return _.controlName === "ytdContributionAmount"
                        ? "text-danger"
                        : "";
                    })
                    .join("")}
                >
                  {contribution.ytdContributionAmount != null &&
                    usCurrency(Number(contribution.ytdContributionAmount))}
                  <div className="text-danger h7 small">
                    {contribution?.errorMessages?.map((_, i) => {
                      if (_.controlName == "ytdContributionAmount") {
                        return `${_.messageDescCode}`;
                      }
                    })}
                  </div>
                </div>
              </>
            </div>
            <div className="column-contribution-calculated-value">
              {contribution.sourceType === "EmployerSources" &&
                (contribution.responsibleMode === "Core" ||
                  contribution.responsibleMode === "Validate") && (
                  <>
                    {usCurrency(
                      Number(contribution.calculatedContributionAmount)
                    )}
                  </>
                )}
            </div>
            {!disabled && (
              <div className="column-contribution-action">
                {errorType != 2 ? (
                  <>
                    {permissions[roleName][menu + "SubMenu"][
                      camelCase(subMenu)
                    ].includes("D")
                      ? [
                          <FontAwesomeIcon
                            icon={faTrashAlt}
                            size="sm"
                            color="#F16973"
                            className="pointer"
                            onClick={() => {
                              setDeleteContributionId(contribution.id);
                              setIsModalOpen(true);
                            }}
                          />,
                        ]
                      : null}
                  </>
                ) : (
                  <div className="d-flex justify-content-between">
                    {permissions[roleName][menu + "SubMenu"][
                      camelCase(subMenu)
                    ].includes("U") ? (
                      <a
                        className="accept-warning"
                        onClick={() => check(contribution)}
                      >
                        <i
                          class="fas fa-exclamation-triangle mr-1"
                          aria-hidden="true"
                          style={{
                            color: "rgb(167, 123, 0)",
                          }}
                        ></i>
                        Accept Warning
                      </a>
                    ) : null}

                    {permissions[roleName][menu + "SubMenu"][
                      camelCase(subMenu)
                    ].includes("D") ? (
                      <FontAwesomeIcon
                        icon={faTrashAlt}
                        size="sm"
                        color="#F16973"
                        className="pointer mt-1"
                        onClick={() => {
                          setDeleteContributionId(contribution.id);
                          setIsModalOpen(true);
                        }}
                      />
                    ) : null}
                  </div>
                )}
              </div>
            )}
          </>
        ) : isLoan ? (
          <>
            <div className="column-loan-plan-id">{planId}</div>
            <div className="column-loan-loan-id">
              <Field
                name={`${fieldName}.loanNumber`}
                size="sm"
                type="text"
                disabled={disabled}
                autoComplete="off"
                value={
                  get(values, `${fieldName}.loanNumber`) === null
                    ? ""
                    : get(values, `${fieldName}.loanNumber`)
                }
                defaultValue={errorItem["loanNumber"]}
                onChange={handleChange}
                component={FieldInput}
              />
            </div>
            <div className="column-loan-amount">
              <Field
                name={`${fieldName}.repaymentAmount`}
                type="text"
                disabled={disabled}
                autoComplete="off"
                defaultValue={errorItem["repaymentAmount"]}
                onChange={handleChange}
                value={
                  get(values, `${fieldName}.repaymentAmount`) === null
                    ? ""
                    : get(values, `${fieldName}.repaymentAmount`)
                }
                isWarning={warningCheck}
                max={9999999.99}
                min={-9999999.99}
                ignoreError={true}
                component={FieldInputDollar}
              />
            </div>
            <div className="column-loan-action">
              {!disabled && (
                <div className="d-flex justify-content-start align-items-center mt-10">
                  {errorType == 2 ? (
                    <>
                      {permissions[roleName][menu + "SubMenu"][
                        camelCase(subMenu)
                      ].includes("U") ? (
                        <a className="mr-2 accept-warning" onClick={() => {}}>
                          <i
                            class="fas fa-exclamation-triangle mr-1"
                            aria-hidden="true"
                            style={{
                              color: "rgb(167, 123, 0)",
                            }}
                          ></i>
                          Accept Warning
                        </a>
                      ) : null}
                      {permissions[roleName][menu + "SubMenu"][
                        camelCase(subMenu)
                      ].includes("D") ? (
                        <FontAwesomeIcon
                          icon={faTrashAlt}
                          size="sm"
                          color="#F16973"
                          className="pointer"
                          onClick={() => removeOne(errorItem)}
                        />
                      ) : null}
                    </>
                  ) : permissions[roleName][menu + "SubMenu"][
                      camelCase(subMenu)
                    ].includes("D") ? (
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      size="sm"
                      color="#F16973"
                      className="pointer"
                      onClick={() => removeOne(errorItem)}
                    />
                  ) : null}
                </div>
              )}
            </div>
          </>
        ) : null}
      </div>
      {error && (
        <div
          className={warningCheck ? "warning-msg-payroll" : "error-msg-payroll"}
        >
          <div
            className={
              warningCheck
                ? "font-weight-msg warning-msg-text"
                : "font-weight-msg error-msg-text"
            }
          >
            {warningCheck ? "Warning Code : " : "Error Code : "}
            {error.slice(0, error.indexOf(" -"))}
            <br />
          </div>
          <div className={warningCheck ? "warning-msg-text" : "error-msg-text"}>
            {" "}
            {error.slice(error.indexOf(" -") + 2, error.length)}
          </div>
        </div>
      )}
    </div>
  );
};

export default PayrollCardBody;
